export const environment = {
  production: true,

  currentUrl: "",
};
